import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Componente de redirecionamento para a tela mesclada de login/esqueci senha
 */
const EsqueciSenhaRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redireciona para a página de login com flag de esqueci senha
        navigate('/login?esqueci-senha=true', { replace: true });
    }, [navigate]);

    return null;
};

export default EsqueciSenhaRedirect;
